<template lang="pug">
div(v-sortable="{handler: '.handler', callback: onSorted}" class="wrap-all")
  div(
    v-for="item in items"
    :data-list-id="item.id"
    :key="item.id"
  )
    div(class="item-inner")
      div(class="item-row")
        div(class="handler")
          v-icon(color='black') menu
        div(class="pr-3 pl-3")
          v-icon(dark :color="item.published ? 'primary' : 'secondary'") done
        div(class="item-name") {{ item.name }}
        div
          v-btn(icon @click.stop="emitter.$emit('sitetree.edit', item)")
            v-icon(small) edit
          v-btn(icon @click.stop="emitter.$emit('sitetree.create', item)")
            v-icon(small) library_add
          v-btn(icon @click.stop="emitter.$emit('sitetree.delete', item)")
            v-icon(small) delete_outline
      div(v-if="item.children" class="item-nested")
        tree-list(:items="item.children" :emitter="emitter")
</template>

<script>
import emitter from '@/emitter'
export default {
  name: 'tree-list',

  data: () => ({
    counter: 1,
    emitter
  }),

  props: {
    index: {
      type: Number,
      default: 0
    },
    items: {
      type: Array,
      default: () => []
    }
  },

  methods: {
    onSorted() {
      const indexes = [...this.$el.childNodes].map(n => +n.dataset.listId)
      this.emitter.$emit('sitetree.sort', indexes)
    }
  }
}
</script>

<style scoped>
.item-row {
  display: flex;
  align-items: center;
}
.item-name {
  flex: 1;
}
.handler {
  cursor: move;
  color: black;
}
.item-inner {
  padding-left: 20px;
}
</style>
